import React from 'react';
import { Image, Skeleton } from 'antd';
import { useDocumentUrl } from '../hooks/useDocumentUrl';

interface DocumentImageProps extends Omit<React.ComponentProps<typeof Image>, 'src'> {
    documentId?: string | null;
    fallbackUrl?: string;
}

export const DocumentImage: React.FC<DocumentImageProps> = ({ documentId, fallbackUrl, ...props }) => {
    // If it's a full URL, just use it directly
    const isFullUrl = documentId?.startsWith('http://') || documentId?.startsWith('https://') || documentId?.startsWith('blob:');
    
    const { data: url, isLoading: loading } = useDocumentUrl(isFullUrl ? null : documentId);
    
    const finalUrl = isFullUrl ? documentId : url || fallbackUrl;

    if (loading) {
        return <Skeleton.Image active style={{ width: props.width || 100, height: props.height || 100 }} />;
    }

    if (!finalUrl) {
        return null; // Or return a custom fallback placeholder if desired
    }

    return <Image src={finalUrl} {...props} />;
};
